// Centralized API paths for Vyapari Ledger Pro

const API = {
  AUTH: {
    LOGIN: "/auth/login",
    SIGNUP: "/auth/signup",
    FORGOT_PASSWORD: "/auth/forgot-password",
  },
  DASHBOARD: {
    SUMMARY: "/dashboard/summary",
  },
  CUSTOMERS: {
    BASE: "/customers",
    BY_ID: (id) => `/customers/${id}`,
    IMPORT: "/customers/import",
    EXPORT: "/customers/export",
  },
  SUPPLIERS: {
    BASE: "/suppliers",
    BY_ID: (id) => `/suppliers/${id}`,
  },
  PRODUCTS: {
    BASE: "/products",
    BY_ID: (id) => `/products/${id}`,
    LOW_STOCK: "/products/low-stock",
    UPDATE_STOCK: (id) => `/products/${id}/stock`,
  },
  TRANSACTIONS: {
    BASE: "/transactions",
    BY_ID: (id) => `/transactions/${id}`,
    PAYMENT: "/transactions/payment",
    EXPENSE: "/transactions/expense",
    RECEIPT: (id) => `/transactions/${id}/receipt`,
  },
  INVOICES: {
    BASE: "/invoices",
    BY_ID: (id) => `/invoices/${id}`,
    STATUS: (id) => `/invoices/${id}/status`,
    PDF: (id) => `/invoices/${id}/pdf`,
    SEND_WHATSAPP: (id) => `/invoices/${id}/send-whatsapp`,
    SEND_EMAIL: (id) => `/invoices/${id}/send-email`,
  },
  REPORTS: {
    DAYBOOK: "/reports/daybook",
    LEDGER: "/reports/ledger",
    PROFIT_LOSS: "/reports/profit-loss",
    BALANCE_SHEET: "/reports/balance-sheet",
    GST: "/reports/gst",
    CASH_FLOW: "/reports/cash-flow",
    EXPORT: "/reports/export",
  },
  SETTINGS: {
    BUSINESS_PROFILE: "/settings/business-profile",
    CURRENCIES: "/settings/currencies",
    BACKUP: "/settings/backup",
    RESTORE: "/settings/restore",
    UPI_QR: "/settings/upi-qr",
  },
  NOTIFICATIONS: {
    BASE: "/notifications",
    REMINDERS: "/notifications/reminders",
    WHATSAPP_REMINDER: "/notifications/whatsapp-reminder",
    MARK_READ: (id) => `/notifications/mark-read/${id}`,
  },
  UTILITY: {
    UPLOAD_BILL: "/utility/upload-bill",
    BUSINESS_SWITCHER: "/utility/business-switcher",
    SWITCH_BUSINESS: (id) => `/utility/switch-business/${id}`,
    GST_VALIDATOR: "/utility/gst-validator",
    EXCHANGE_RATES: "/utility/exchange-rates",
  },
};

export default API; 